import { History } from "history";

import {
  ADD_SUPPLICATION,
  ADD_SUPPLICATION_ERROR,
  ADD_SUPPLICATION_SUCCESS,
  AddSupplicationAction,
  AddSupplicationErrorAction,
  AddSupplicationSuccessAction,
  DELETE_SUPPLICATION,
  DELETE_SUPPLICATION_CONSENT,
  DELETE_SUPPLICATION_ERROR,
  DELETE_SUPPLICATION_SUCCESS,
  DeleteSupplicationAction,
  DeleteSupplicationConsentAction,
  DeleteSupplicationErrorAction,
  DeleteSupplicationSuccessAction,
  GET_SUPPLICATION,
  GET_SUPPLICATIONS,
  GET_SUPPLICATIONS_ERROR,
  GET_SUPPLICATIONS_SUCCESS,
  GET_SUPPLICATION_ERROR,
  GET_SUPPLICATION_SUCCESS,
  GetSupplicationAction,
  GetSupplicationErrorAction,
  GetSupplicationSuccessAction,
  GetSupplicationsAction,
  GetSupplicationsErrorAction,
  GetSupplicationsSuccessAction,
  UPDATE_SUPPLICATION,
  UPDATE_SUPPLICATION_ERROR,
  UPDATE_SUPPLICATION_SUCCESS,
  UpdateSupplicationAction,
  UpdateSupplicationErrorAction,
  UpdateSupplicationSuccessAction,
} from "./actionTypes";
import {
  CreateSupplicationRequest,
  SupplicationDto,
  PaginateQuery,
  UpdateSupplicationRequest,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Supplications

export const getSupplications = (
  request: PaginateQuery,
  history: History
): GetSupplicationsAction => {
  return {
    type: GET_SUPPLICATIONS,
    payload: { request, history },
  };
};

export const getSupplicationsSuccess = (
  response: Paginated<SupplicationDto>
): GetSupplicationsSuccessAction => {
  return {
    type: GET_SUPPLICATIONS_SUCCESS,
    payload: response,
  };
};

export const getSupplicationsError = (
  error: any
): GetSupplicationsErrorAction => {
  return {
    type: GET_SUPPLICATIONS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Supplication

export const getSupplication = (
  id: string,
  history: History
): GetSupplicationAction => {
  return {
    type: GET_SUPPLICATION,
    payload: { id, history },
  };
};

export const getSupplicationSuccess = (
  response: SupplicationDto
): GetSupplicationSuccessAction => {
  return {
    type: GET_SUPPLICATION_SUCCESS,
    payload: response,
  };
};

export const getSupplicationError = (
  error: any
): GetSupplicationErrorAction => {
  return {
    type: GET_SUPPLICATION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Supplication

export const addSupplication = (
  request: CreateSupplicationRequest,
  history: History
): AddSupplicationAction => {
  return {
    type: ADD_SUPPLICATION,
    payload: { request, history },
  };
};

export const addSupplicationSuccess = (): AddSupplicationSuccessAction => {
  return {
    type: ADD_SUPPLICATION_SUCCESS,
    payload: null,
  };
};

export const addSupplicationError = (
  error: any
): AddSupplicationErrorAction => {
  return {
    type: ADD_SUPPLICATION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Supplication

export const updateSupplication = (
  id: string,
  request: UpdateSupplicationRequest,
  history: History
): UpdateSupplicationAction => {
  return {
    type: UPDATE_SUPPLICATION,
    payload: { id, request, history },
  };
};

export const updateSupplicationSuccess =
  (): UpdateSupplicationSuccessAction => {
    return {
      type: UPDATE_SUPPLICATION_SUCCESS,
      payload: null,
    };
  };

export const updateSupplicationError = (
  error: any
): UpdateSupplicationErrorAction => {
  return {
    type: UPDATE_SUPPLICATION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Supplication

export const deleteSupplicationConsent = (
  id: string
): DeleteSupplicationConsentAction => {
  return {
    type: DELETE_SUPPLICATION_CONSENT,
    payload: id,
  };
};

export const deleteSupplication = (
  id: string,
  history: History
): DeleteSupplicationAction => {
  return {
    type: DELETE_SUPPLICATION,
    payload: { id, history },
  };
};

export const deleteSupplicationSuccess =
  (): DeleteSupplicationSuccessAction => {
    return {
      type: DELETE_SUPPLICATION_SUCCESS,
      payload: null,
    };
  };

export const deleteSupplicationError = (
  error: any
): DeleteSupplicationErrorAction => {
  return {
    type: DELETE_SUPPLICATION_ERROR,
    payload: error,
  };
};

//#endregion
